module.exports = __webpack_public_path__ + "img/0Q3A6952_P_L_Wood_MockedUp.43cfb659.jpg";